import React from 'react'
import { IconButton } from '../../../../shared/components/buttons/icon-button/IconButton'
import { IconEye } from '../../../../shared/components/icons/IconEye'
import { IconEyeOff } from '../../../../shared/components/icons/IconEyeOff'
import { usePostLanguageComplianceUpdateStateMutation } from '../../../../app/api'

interface HiddenActionCellProps {
  url: string
  is_hidden: boolean
  project: string
  country: string
  onToggle: () => void
}

export const HiddenActionCell = ({
  url,
  is_hidden,
  project,
  country,
  onToggle,
}: HiddenActionCellProps) => {
  const [updateState] = usePostLanguageComplianceUpdateStateMutation()

  return (
    <IconButton
      size='lg'
      onClick={() => {
        if (!project) return
        updateState({
          stateForm: {
            project_id: Number(project),
            country_id: country,
            urls: [url],
            is_hidden: is_hidden ? 0 : 1,
          },
        }).then(() => {
          onToggle()
        })
      }}
    >
      {is_hidden ? <IconEye color='#A059FF' /> : <IconEyeOff color='#A059FF' />}
    </IconButton>
  )
}
